import { defineAsyncComponent, h } from "vue";
import store from "@/stores";
const versioned = (v1, v2) => {
  const oldDesign = defineAsyncComponent(v1);
  const newDesign = defineAsyncComponent(v2);
  return {
    name: "VersionedRoute",
    computed: {
      isPortalV2() {
        return store.getters["organization/isPortalV2"];
      },
    },
    render() {
      return h(this.isPortalV2 ? newDesign : oldDesign);
    },
  };
};

export default [
  {
    path: "/login",
    redirect: "/signin",
  },
  {
    path: "/signin",
    component: versioned(
      () => import("@/views/signin/SignInView.vue"),
      () => import("@/views/v2/SignInView.vue"),
    ),
    meta: {
      authentication: { required: false, redirectAuthenticated: "/" },
      hideNav: true,
    },
  },
  {
    path: "/signin/forgot",
    component: versioned(
      () => import("@/views/signin/ForgotView.vue"),
      () => import("@/views/v2/ForgotView.vue"),
    ),
    meta: {
      authentication: { required: false, redirectAuthenticated: "/" },
    },
  },
  {
    path: "/signin/forgot/success",
    component: () => import("@/views/signin/ForgotSuccessView.vue"),
    meta: {
      authentication: { required: false, redirectAuthenticated: "/" },
    },
  },
  {
    path: "/signin/new-password",
    component: () => import("@/views/signin/NewPasswordView.vue"),
    meta: {
      authentication: { required: false, redirectAuthenticated: "/" },
      hideNav: true,
    },
  },
];
